module.exports = __webpack_public_path__ + "media/components/assets/img/pksoslo_opengraph-ff86e904bfd9f37ab99fd3df4cc6719e.png";